import { useAtom, useAtomValue } from 'jotai'
import { preferredAvatarAtom } from '@/src/stores/accounts/atoms'
import { userAtom } from '@/src/stores/user/atoms'
import { ManageAccount as ManageAccountContent } from '../../accounts/manage-account'

export function ManageAccount() {
  // const { updateView } = usePortfolioView()
  const user = useAtomValue(userAtom)
  const [avatar, setAvatar] = useAtom(preferredAvatarAtom)

  if (!user) return null

  return (
    <ManageAccountContent
      user={user}
      avatar={avatar === 'not-set' ? undefined : avatar}
      onAvatarChange={setAvatar}
      // onEditName={() => updateView({ view: 'edit-account-name' })}
      // onEditEmail={() => updateView({ view: 'edit-account-email' })}
      showContainer={false}
      showDeleteAccount={user.id !== 'guest'}
    />
  )
}
